import apiClient from '../lib/apiClient';

const exitLettersService = {
  // Get all exit letters
  getExitLetters: async (filters = {}) => {
    try {
      const result = await apiClient.get('/exit-letters', filters);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch exit letters' };
    }
  },

  // Get exit letter by ID
  getExitLetter: async (id) => {
    try {
      const result = await apiClient.get(`/exit-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to fetch exit letter' };
    }
  },

  // Create exit letter
  createExitLetter: async (data) => {
    try {
      const result = await apiClient.post('/exit-letters', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to create exit letter' };
    }
  },

  // Preview exit letter
  previewExitLetter: async (data) => {
    try {
      const result = await apiClient.post('/exit-letters/preview', data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to preview exit letter' };
    }
  },

  // Update exit letter
  updateExitLetter: async (id, data) => {
    try {
      const result = await apiClient.put(`/exit-letters/${id}`, data);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to update exit letter' };
    }
  },

  // Delete exit letter
  deleteExitLetter: async (id) => {
    try {
      const result = await apiClient.delete(`/exit-letters/${id}`);
      return result;
    } catch (error) {
      return { success: false, error: error.message || 'Failed to delete exit letter' };
    }
  },

  // Download exit letter
  downloadExitLetter: async (id) => {
    try {
      // Use standard fetch here to get blob response
      const token = localStorage.getItem('erp_token');
      const response = await fetch(`${apiClient.baseURL}/exit-letters/${id}/download`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      
      if (!response.ok) {
        throw new Error('Failed to download document');
      }
      
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `Exit_Letter_${id}.html`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
      
      return { success: true };
    } catch (error) {
      return { success: false, error: error.message || 'Failed to download exit letter' };
    }
  }
};

export default exitLettersService;

